module.exports = __webpack_public_path__ + "media/images/front/common/new_mrso_logo-8cbce908c89e0bcaa56f96c805543fa5.png";